const NotificationsRoutes = {
  getNotifications: 'notifications',
  getNotificationCount: 'notifications/count/unread',
};

export default NotificationsRoutes